import { YM_ID } from '@trwl/constants';

export const ym = (event: string) => {
  if (typeof window !== 'undefined' && window.ym)
    window.ym(YM_ID, 'reachGoal', event);
};
